import {
    NorthamptonshireRecordType,
    NorthamptonshireRecordSubType
} from "./NorthantsRecordTypes";

import {
    IRecordTypeFeatureInfoClick,
    RecordTypeResource,
    IRecordTypeHeading,    
    IMappingTextPack
} from "esdm-map";
import { ILayerGroup } from "esdm-map/dist/layers/groups/ILayerGroup";


let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monuments"
    });

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Event,
        recordSubTypeCode: null,
        heading: "Events"
    });

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designations"
    });

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Designation,
        recordSubTypeCode: NorthamptonshireRecordSubType.ListedBuilding,
        heading: "Listed Buildings"
    });

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Designation,
        recordSubTypeCode: NorthamptonshireRecordSubType.RegisteredParksAndGardens,
        heading: "Registered Parks and Gardens"
    });

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Designation,
        recordSubTypeCode: NorthamptonshireRecordSubType.ScheduledMonument,
        heading: "Scheduled Monuments"
    });  

    items.push({
        recordTypeCode: NorthamptonshireRecordType.Designation,
        recordSubTypeCode: NorthamptonshireRecordSubType.ConservationArea,
        heading: "Conservation Areas"
    });  
    
    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === NorthamptonshireRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        return {
            id: featureProperties.id,
            uid: featureProperties.uid,
            ref: featureProperties.ref,
            name: featureProperties.name,
            recordType: featureProperties.rectype,
            recordSubType: featureProperties.recsubtype,
            recordSubTypeCode: featureProperties.recsubtypecode,
            data: featureProperties,
            heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
            layerGroup: layerGroup
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string 
    {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = recordTypeInfoClick.layerGroup.layerType;

        //add controller (or any arbitrary data) to the data object
        switch (recordTypeInfoClick.recordType.toLowerCase()) {
            case "mon":                
                recordTypeInfoClick.data.controller = "Monument";               
                break;
            case "event":
                recordTypeInfoClick.data.controller = "Event";               
                break;
            case "desig":
                recordTypeInfoClick.data.controller = "Designation";               
                break;           
        }

        html = `
                     <li>
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                        &nbsp;
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}">                               
                            <span>[name]</span>               
                        </a>
                        <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                            <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                        </a>
                     </li>`;

        return html;
    }

    
}